// extracted by mini-css-extract-plugin
export default {"header":"Header_header__D8yk4","title":"Header_title__yhnto","rates":"Header_rates__2ncs0","flag":"Header_flag__9+THP"};